import React from 'react'
import { IoIosArrowForward } from "react-icons/io";
import { useState } from 'react';


import { CiGlobe } from "react-icons/ci";
import { LuAward } from "react-icons/lu";
import { IoIosNotifications } from "react-icons/io";
import { CiSettings } from "react-icons/ci";
import Domain from './sitebradingtabs/domain';
import ResellerInfomation from './sitebradingtabs/ResellerInfomation';
import Notification from './sitebradingtabs/Notification';
import SMTPSetting from './sitebradingtabs/SMTPSetting';



function SiteBranding() {

    const [activeTab, setActiveTab] = useState("Domain");

    const tabList = [
        {
            id: "Domain", label: "Domain", icon: <CiGlobe />
            , component: <Domain />
        },
        {
            id: "ResellerInfomation", label: "Reseller Infomation", icon: <LuAward />
            , component: <ResellerInfomation />
        },
        {
            id: "Notification", label: "Notification", icon: <IoIosNotifications />
            , component: <Notification />
        },
        {
            id: "SMTPSetting", label: "SMTP Setting", icon: <CiSettings />
            , component: <SMTPSetting />
        }
    ];

    return (
        <>
            <div className='pt-[70px] pb-[50px] px-4 min-h-screen dark:bg-[#121519]'>
                <div className='border-b-[1px] border-[#cfcdcd] pb-1'>
                    <h1 className='text-[#000] font-semibold text-[20px] dark:text-[#fff]'>Site Branding</h1>
                    <div className='text-[#454546] dark:text-[#fff] text-[12px] font-semibold flex items-center cursor-pointer gap-1'>
                        <span>Home</span> <IoIosArrowForward />
                        <span>Admin</span><IoIosArrowForward />
                        <span>Site Branding</span>
                    </div>
                </div>

                <div className='w-[100%]  flex flex-col md:flex-row mt-8'>
                    <div className='w-[100%] md:w-[30%] overflow-hidden mb-4 md:mb-0'>
                        {tabList.map((item) => (
                            <div
                                onClick={() => setActiveTab(item.id)}
                                className={`p-2 ${activeTab === item.id ? 'border-[#3f7fca]' : 'border-[#e3e9ef]'} w-[100%] border-[1px] first:rounded-t-lg last:rounded-b-lg flex items-center gap-2 ${activeTab === item.id ? 'text-[#3f7fca] dark:text-[#3f7fca] ' : 'text-[#000] dark:text-[#fff]'} cursor-pointer d'`}>
                                {item.icon}
                                <span className='font-semibold text-[13px]'>{item.label}</span>
                            </div>
                        ))}
                    </div>

                    <div className='w-[100%] md:w-[70%] md:pl-4'>
                        {tabList.find((t) => t.id === activeTab)?.component}
                    </div>
                </div>
            </div>
        </>
    )
}

export default SiteBranding
